import { useState } from "react"
import Restaurar from "../../page/login/Restaurar"
import RestPrivateAntesala from "../../../helpers/RestPrivateApi"
import Alerts from "../../components/Alerts/Alerts"
import { useNavigate } from "react-router-dom"

const RestaurarController = () => {
    const navigation = useNavigate();
    const [loading, setLoading] = useState(false)
    const [form, setForm] = useState({
        email: ""
    })

    const onClick = async (e) => {
        switch (e.target.name) {
            case 'enviar':{

                setLoading(true)
                let dataForm = new FormData();
                dataForm.append("email", form.email);

                const response = await RestPrivateAntesala({
                    method: "post",
                    url: "/auth/recuperar-contraseña",
                    formData: dataForm,
                    setLoading: setLoading,
                  });
        
                  if (response.status == 201 || response.status == 200) {
                    Alerts({
                      msg: "Alert",
                      title: response.data.msg,
                      code: "401",
                      type: "success",
                    });
        
                    return navigation("/");
                  } else {
        
                    Object.keys(response.data.msg).map((key) => {
                      if(response.data.msg[key][0] == "The email has already been taken."){
                        return Alerts({
                          msg: "Warning",
                          title: "El email ya se encuentra registrado",
                          code: "201",
                          type: "error",
                        });
                      } else {
                        return Alerts({
                          msg: "Warning",
                          title: "Ocurrio un error vuelve a intentarlo mas tarde",
                          code: "201",
                          type: "error",
                        });
                      }
                    })
                    
                  }
            }break;
        
            default:
                break;
        }
    }

    const onChange = (e) => {
        switch (e.target.name) {
            case 'email':{
                setForm({
                    ...form, 
                    [e.target.name]: e.target.value
                })
            }break;
            default:
                break;
        }
    }


    return (
        <Restaurar onChange={onChange} onClick={onClick} form={form} loading={loading}/>
    )
}

export default RestaurarController